import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckCircle2Icon, SparklesIcon, ZapIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  emoji: '🔥',
  title: 'Manual de Juegos Acuáticos',
  desc: '+50 dinámicas recreativas organizadas por edad.',
  value: '$9'
}, {
  num: '02',
  emoji: '📅',
  title: 'Agenda del Profe de Natación',
  desc: 'El planner definitivo para organizar lecciones y asistencia.',
  value: '$8'
}, {
  num: '03',
  emoji: '📱',
  title: 'Guía "Clase Rescate"',
  desc: 'Sesiones rápidas para cuando te cambian el grupo a último minuto.',
  value: '$7'
}, {
  num: '04',
  emoji: '💪',
  title: 'Guía de Preparación Física',
  desc: 'Rutinas fuera del agua para potenciar el nado.',
  value: '$9'
}, {
  num: '05',
  emoji: '🏆',
  title: 'Diplomas y Certificados Finales',
  desc: 'Para premiar el esfuerzo de tus pequeños nadadores.',
  value: '$8'
}, {
  num: '06',
  emoji: '📝',
  title: 'Reglamento Interno para Padres',
  desc: 'Documento listo para entregar y evitar problemas de disciplina.',
  value: '$8'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-24 px-4 relative overflow-hidden" data-id="element-28">
      {/* Decorative blobs */}
      <div aria-hidden className="absolute top-0 -left-32 w-[500px] h-[500px] bg-secondary/5 rounded-full blur-3xl pointer-events-none" data-id="element-29" />
      <div aria-hidden className="absolute bottom-0 -right-32 w-[500px] h-[500px] bg-secondary/5 rounded-full blur-3xl pointer-events-none" data-id="element-30" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-31">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-32">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary/10 border border-secondary/20 mb-6" data-id="element-33">
            <GiftIcon className="w-4 h-4 text-secondary" data-id="element-34" />
            <span className="text-sm font-semibold text-secondary tracking-wide uppercase" data-id="element-35">
              Bonos exclusivos
            </span>
          </div>

          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-text-main mb-4 tracking-tight" data-id="element-36">
            +6 Bonos GRATIS al instante
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto mb-6" data-id="element-37">
            Recursos extra para que arranques con todo —
            <span className="text-text-main font-semibold" data-id="element-38">
              {' '}
              sin costo adicional
            </span>
            .
          </p>

          {/* Value strip */}
          <div className="inline-flex items-center gap-3 flex-wrap justify-center" data-id="element-39">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-bg-alt border border-border-light" data-id="element-40">
              <span className="text-text-sec text-sm font-medium" data-id="element-41">
                Valor real:
              </span>
              <span className="text-badge-red font-black text-lg line-through decoration-2" data-id="element-42">
                $49 USD
              </span>
            </span>
            <SparklesIcon className="w-5 h-5 text-secondary" data-id="element-43" />
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-secondary/10 border border-secondary/30" data-id="element-44">
              <span className="text-text-main text-sm font-semibold" data-id="element-45">
                Hoy pagás:
              </span>
              <span className="text-secondary font-black text-lg" data-id="element-46">$0</span>
            </span>
          </div>
        </motion.div>

        {/* Bonuses grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5" data-id="element-47">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} whileHover={{
          y: -4
        }} className="group relative bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light overflow-hidden transition-all duration-300 hover:border-secondary/40 hover:shadow-[0_15px_40px_-15px_rgba(245,158,11,0.25)]" data-id="element-48">
              {/* Accent gradient bar */}
              <div className="h-1 w-full bg-gradient-to-r from-secondary via-amber-400 to-secondary opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-49" />

              {/* Subtle corner glow */}
              <div aria-hidden className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-secondary/20 opacity-0 group-hover:opacity-100 blur-3xl transition-opacity duration-500 pointer-events-none" data-id="element-50" />

              <div className="p-5 sm:p-6 flex items-start gap-4 sm:gap-5 relative z-10" data-id="element-51">
                {/* Emoji + number stack */}
                <div className="relative flex-shrink-0" data-id="element-52">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-secondary/25 to-secondary/5 border border-secondary/30 flex items-center justify-center text-2xl sm:text-3xl shadow-inner group-hover:from-secondary/40 group-hover:scale-105 transition-all duration-300" data-id="element-53">
                    {bonus.emoji}
                  </div>
                  <span className="absolute -top-2 -left-2 min-w-[26px] h-[26px] px-1.5 rounded-full bg-bg-main border-2 border-secondary text-secondary text-[11px] font-black flex items-center justify-center shadow-md" data-id="element-54">
                    {bonus.num}
                  </span>
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0" data-id="element-55">
                  <div className="flex items-start justify-between gap-2 mb-1" data-id="element-56">
                    <h4 className="text-text-main font-bold text-base sm:text-lg leading-snug" data-id="element-57">
                      {bonus.title}
                    </h4>
                  </div>
                  <p className="text-text-sec text-sm leading-relaxed mb-3" data-id="element-58">
                    {bonus.desc}
                  </p>

                  {/* Footer row: value + GRATIS */}
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-59">
                    <span className="text-text-sec text-xs line-through opacity-70" data-id="element-60">
                      Valor: {bonus.value}
                    </span>
                    <span className="inline-flex items-center gap-1 bg-secondary/15 text-secondary border border-secondary/30 px-2.5 py-1 rounded-md font-black text-xs uppercase tracking-wider shadow-[0_0_12px_rgba(245,158,11,0.2)]" data-id="element-61">
                      <ZapIcon className="w-3 h-3" strokeWidth={2.5} data-id="element-62" />
                      Gratis
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Footer reassurance */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-10 flex items-center justify-center gap-2 flex-wrap text-text-sec text-sm" data-id="element-63">
          <span className="inline-flex items-center gap-1.5" data-id="element-64">
            <CheckCircle2Icon className="w-4 h-4 text-secondary" data-id="element-65" />
            Acceso inmediato
          </span>
          <span className="text-border-light" data-id="element-66">•</span>
          <span data-id="element-67">Todos los bonos en PDF</span>
          <span className="text-border-light" data-id="element-68">•</span>
          <span data-id="element-69">Sin letra chica</span>
        </motion.div>
      </div>
    </section>;
}